import countriesAppImg from "./portadaCountriesAPP.png";
import ecommerce from "./ecommerce.png";
import weatherAppImg from "./weatherApp.png";
import videogamespi from "./videogamespi.png";
import pokemonpi from "./pokemonapi.png";
import portfolioImg from "./portfolio.png";
import ecommerceVideo from "./ecommerceVideo.mp4";
import countriesVideo from "./countiesVideo.mp4";
import weatherApp from "./weatherApp.mp4";
import videoGames from "./videoGames.mp4";

export const info = [
  {
    id: 0,
    name: "Countries App",
    desc_es:
      "App de búsqueda y filtrado de países con datos de la API REST Countries. Permite explorar estadísticas, filtrar por región y gestionar favoritos. Stack: React, Redux, Node.js, PostgreSQL.",
    desc_en:
      "Country search and filter app using the REST Countries API. Browse stats, filter by region and manage favourites. Stack: React, Redux, Node.js, PostgreSQL.",
    img: countriesAppImg,
    video: countriesVideo,
    deploy: "https://appcountries-ten.vercel.app/",
    repository: "https://github.com/Mjosuex85/AppCountries",
  },

  {
    id: 1,
    name: "E-commerce",
    desc_es:
      "Tienda online de videojuegos con carrito, pagos con MercadoPago y panel de administración. Stack: React, Node.js, Express, PostgreSQL, Auth0.",
    desc_en:
      "Video game online store with cart, MercadoPago payments and admin dashboard. Stack: React, Node.js, Express, PostgreSQL, Auth0.",
    img: ecommerce,
    video: ecommerceVideo,
    deploy: "https://e-commerce-videogames.vercel.app/",
    repository: "https://github.com/Mjosuex85/e-commerce_client",
  },

  {
    id: 2,
    name: "Wiki Games",
    desc_es:
      "Enciclopedia de videojuegos con búsqueda, filtros avanzados y paginación, consumiendo la API de RAWG. Stack: React, Redux, Node.js, PostgreSQL.",
    desc_en:
      "Video game encyclopedia with search, advanced filters and pagination, powered by the RAWG API. Stack: React, Redux, Node.js, PostgreSQL.",
    img: videogamespi,
    video: videoGames,
    deploy: false,
    repository: "https://github.com/Mjosuex85/videogames",
  },

  {
    id: 3,
    name: "Weather App",
    desc_es:
      "Aplicación del tiempo con geolocalización y pronóstico extendido usando la API de OpenWeather. Stack: React, Chart.js, CSS.",
    desc_en:
      "Weather app with geolocation and extended forecast powered by the OpenWeather API. Stack: React, Chart.js, CSS.",
    img: weatherAppImg,
    video: weatherApp,
    deploy: false,
    repository: "https://github.com/Mjosuex85/Weather-DataApp",
  },

  {
    id: 4,
    name: "Pokemon Api",
    desc_es:
      "Pokédex interactiva con filtros por tipo, estadísticas y sistema de favoritos. Datos obtenidos de PokeAPI. Stack: React, Redux, Node.js, PostgreSQL.",
    desc_en:
      "Interactive Pokédex with type filters, stats display and favourites system. Data from PokeAPI. Stack: React, Redux, Node.js, PostgreSQL.",
    img: pokemonpi,
    video: false,
    deploy: false,
    repository: "https://github.com/Mjosuex85/Pokemon-PI-MarioVidal",
  },

  {
    id: 5,
    name: "Portfolio MV",
    desc_es:
      "Este portfolio — SPA bilingüe con integración a la API de GitHub, carrusel infinito y envío de emails. Stack: React, Redux, Vercel Serverless.",
    desc_en:
      "This portfolio — bilingual SPA with GitHub API integration, infinite carousel and email sending. Stack: React, Redux, Vercel Serverless.",
    img: portfolioImg,
    video: false,
    deploy: "https://e-commerce-videogames.vercel.app/",
    repository: false,
  },
];
